import * as React from "react";
import classnames from "classnames";
import { Util } from "@grandvisionhq/common";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { Icon } from "@grandvisionhq/icons";
import { useCartStorage } from "@grandvisionhq/lib-utils-cart";
import { useIsClient } from "@grandvisionhq/lib-utils-react";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { CartCounter } from "../../../components/CartCounter/CartButton/components/CartCounter/CartCounter.js";
import { GET_TOTAL_LINE_ITEMS } from "../../../operations/queries/CartButton/operations/queries/get-total-line-items.js";
import { getUnrecoverableValidationErrors } from "../../../utils/CartButton/utils/get-unrecoverable-validation-errors.js";
/* empty css                                                */
const CartButtonContainer = ({ href, className, label, tabIndex }) => {
  const intl = useIntl();
  const { isClearCartOnAllErrorsEnabled } = useFeatureToggles();
  const [cartData, { setCartCount, reset }] = useCartStorage();
  const isClient = useIsClient();
  const handleOnCompleted = React.useCallback(
    (data) => {
      const validationErrors = data?.cart?.validationErrors;
      const failures = data?.cart?.failures;
      if (validationErrors && getUnrecoverableValidationErrors(validationErrors).length || failures?.length) {
        reset();
        return;
      }
      data?.cart?.cart && setCartCount(data?.cart?.cart.numberOfItems);
    },
    [setCartCount, reset]
  );
  const [getTotalLineItems] = useLazyQuery(
    GET_TOTAL_LINE_ITEMS,
    {
      onCompleted: handleOnCompleted,
      onError: (error) => {
        console.error(error);
        if (isClearCartOnAllErrorsEnabled) {
          reset();
        }
      }
    }
  );
  const tealiumAttributes = {
    "data-element-id": `MainNav_Bag`
  };
  const ariaLabel = React.useMemo(() => {
    return cartData.cartCount === 0 ? intl.getLabel("cart.emptyCart.title") : Util.getCartTotalsTitle(
      cartData.cartCount,
      intl,
      "cart.minicart.totalsTitle.singular",
      "cart.minicart.totalsTitle"
    );
  }, [cartData.cartCount, intl]);
  React.useEffect(() => {
    if (cartData.cartId) {
      getTotalLineItems({
        variables: { id: cartData.cartId }
      });
    }
  }, [cartData.cartId, getTotalLineItems]);
  if (!isClient) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      className: classnames("cart-button", className),
      href,
      title: label,
      tabIndex,
      "aria-label": tabIndex === -1 ? "" : ariaLabel,
      ...tealiumAttributes
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "shopping-bag" }),
    /* @__PURE__ */ React.createElement(CartCounter, { count: cartData.cartCount })
  );
};
export {
  CartButtonContainer
};
//# sourceMappingURL=CartButtonContainer.js.map
